import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ArcoVue from '@arco-design/web-vue'
// Only the icons this console actually renders. Registering the icon
// plugin instead pulls in all 287 of them, and a default-export plugin
// cannot be tree-shaken, so every build shipped the whole set.
import {
  IconApps,
  IconMenuUnfold,
  IconBarChart,
  IconArrowLeft,
  IconBug,
  IconCaretDown,
  IconCaretUp,
  IconCheck,
  IconCheckCircleFill,
  IconClose,
  IconCode,
  IconDashboard,
  IconDown,
  IconExport,
  IconFullscreen,
  IconFullscreenExit,
  IconGift,
  IconLock,
  IconMenu,
  IconPlus,
  IconPublic,
  IconRefresh,
  IconSafe,
  IconSearch,
  IconSettings,
  IconSkin,
  IconThunderbolt,
  IconUpload,
  IconUser,
  IconArrowDown,
  IconExclamationCircleFill,
  IconLaunch,
  IconLeft,
  IconRight,
} from '@arco-design/web-vue/es/icon'
import '@arco-design/web-vue/dist/arco.css'
// After arco.css on purpose: it overrides Arco's radius tokens.
import './styles/base.css'
import './styles/dark.css'
import './styles/twotone.css'
import './styles/square.css'
import './styles/nowrap.css'
// Last: the phone layout overrides the rules above it.
import './styles/mobile.css'
import App from './App.vue'
import router from './router'
import { i18n } from './i18n'
import { applyBranding } from './utils/branding'
import { bootFailed, recoverStaleChunks } from './utils/boot'

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(i18n)
app.use(ArcoVue)
app.component('IconApps', IconApps)
app.component('IconMenuUnfold', IconMenuUnfold)
app.component('IconBarChart', IconBarChart)
app.component('IconArrowLeft', IconArrowLeft)
app.component('IconBug', IconBug)
app.component('IconCaretDown', IconCaretDown)
app.component('IconCaretUp', IconCaretUp)
app.component('IconCheck', IconCheck)
app.component('IconClose', IconClose)
app.component('IconCheckCircleFill', IconCheckCircleFill)
app.component('IconCode', IconCode)
app.component('IconDashboard', IconDashboard)
app.component('IconDown', IconDown)
app.component('IconExport', IconExport)
app.component('IconFullscreen', IconFullscreen)
app.component('IconFullscreenExit', IconFullscreenExit)
app.component('IconGift', IconGift)
app.component('IconLock', IconLock)
app.component('IconMenu', IconMenu)
app.component('IconPlus', IconPlus)
app.component('IconPublic', IconPublic)
app.component('IconRefresh', IconRefresh)
app.component('IconSafe', IconSafe)
app.component('IconSearch', IconSearch)
app.component('IconSettings', IconSettings)
app.component('IconSkin', IconSkin)
app.component('IconThunderbolt', IconThunderbolt)
app.component('IconUpload', IconUpload)
app.component('IconUser', IconUser)
app.component('IconArrowDown', IconArrowDown)
app.component('IconExclamationCircleFill', IconExclamationCircleFill)
app.component('IconLaunch', IconLaunch)
app.component('IconLeft', IconLeft)
app.component('IconRight', IconRight)

// Branding is fetched but deliberately not awaited: it is a title and an
// icon, and blocking the whole console on one more network round trip
// would make a slow or unreachable settings endpoint look like an app
// that will not start.
void applyBranding()

// Mount only once the first navigation (and its guards) has resolved.
// Mounting synchronously renders App against a not-yet-resolved route
// whose meta is empty, so App's `layout !== 'blank'` check evaluates true
// and flashes the full console shell for a frame before the router
// settles on the blank-layout login page.
recoverStaleChunks(router)
router.isReady().then(() => app.mount('#app'), bootFailed)
